module.exports = __webpack_public_path__ + "media/images/ui-bg_highlight-soft_75_cccccc_1x100-6684cfa91789e479fb5bee3dceed3f1a.png";